import { useRef, useState } from "react";
import { BaseItem, Image } from "zhihao-ui-react";
import ZhEmptyMedia from "@/views/components/zhEmptyMedia";

export interface MediaWrapProps {
    label: string;
    mediaUrl?: string;
    mediaType: "image" | "video";
    width?: string;
    height?: string;
    tip?: string;
    icon?: string;
}

/** 图片/视频媒体展示，保留旧版空态、预览和视频播放交互。 */
export function MediaWrap({
    label,
    mediaUrl,
    mediaType,
    width = "254px",
    height = "140px",
    tip = "暂无图片或视频"
}: MediaWrapProps) {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [playing, setPlaying] = useState(false);
    const play = () => {
        void videoRef.current?.play();
        setPlaying(true);
    };
    return (
        <BaseItem label={label} infoDirection="vertical">
            <div className="media-wrap" style={{ width, height }}>
                {mediaUrl && mediaType === "video" ? (
                    <video
                        ref={videoRef}
                        src={mediaUrl}
                        controls={playing}
                        onPause={() => setPlaying(false)}
                        onPlay={() => setPlaying(true)}
                    />
                ) : null}
                {mediaUrl && mediaType === "image" ? <Image src={mediaUrl} preview /> : null}
                {!mediaUrl ? (
                    <ZhEmptyMedia height={height} tip={tip} width={width} />
                ) : null}
                {mediaUrl && mediaType === "video" && !playing ? (
                    <button type="button" onClick={play} aria-label="播放视频">
                        ▶
                    </button>
                ) : null}
            </div>
        </BaseItem>
    );
}

export default MediaWrap;
